import { ExtStatsUpdateLogI } from "./stats-update-log.result.ext";
import { ExtStatsUpdateLogQueryI } from "./stats-update-log.query.ext";
import { StatsUpdateLogI } from "./stats-update-log.result.int";
import { StatsUpdateLogQueryI } from "./stats-update-log.query.int";
import { frontendRelease } from "src/main";
import { nullToEmptyString } from "src/app/shared/helpers/shared-zero-to-null.function";

export const MapStatsUpdateLog = {
    mapQuery: (int: StatsUpdateLogQueryI): ExtStatsUpdateLogQueryI => {
        return {
            request: {
                app: nullToEmptyString(int.app),
                bundleVersion: nullToEmptyString(int.bundleVersion),
                channelType: nullToEmptyString(int.channelType),
                customer: nullToEmptyString(int.customer),
                details: nullToEmptyString(int.details),
                error: nullToEmptyString(int.error),
                eventAt: nullToEmptyString(int.eventAt),
                frontEndVersion: frontendRelease,
                liveUpdate: nullToEmptyString(int.liveUpdate),
                liveUpdateChannel: nullToEmptyString(int.liveUpdateChannel),
                platform: nullToEmptyString(int.platform),
                platformVersion: nullToEmptyString(int.platformVersion),
                randomDeviceId: nullToEmptyString(int.randomDeviceId),
                updateCheckType: nullToEmptyString(int.updateCheckType),
                steps: nullToEmptyString(int.steps),
                status: nullToEmptyString(int.status),
                step: nullToEmptyString(int.step),
                username: nullToEmptyString(int.username),
            }
        };
    },
    mapResult: (_ext: ExtStatsUpdateLogI, _params): StatsUpdateLogI => {
        return {

        };
    }
};
